export default __webpack_public_path__ + "static/media/Standing sculptures of Buddha.7f13cad4.png";